import data from "../../.sourceflow/insights.json";
import CollectionHelper from "@/helpers/CollectionHelper";
import { sortByDate } from "@/functions/sortByDate";

class InsightsCollectionHelper extends CollectionHelper {
  fetch({ limit = null, parent = false, exclude = null, filter = null, map = null } = {}) {
    let items = sortByDate(this.collection.getItems(), "published");

    if (filter) {
      items = items.filter(filter);
    }

    if (parent !== false) {
      items = items.filter((i) => i.parent.id === parent);
    }

    if (exclude) {
      items = items.filter((i) => !exclude.includes(i.id));
    }

    if (limit) {
      items = items.slice(0, limit);
    }

    if (map) {
      items = items.map(map);
    }

    return items;
  }
}

export const insights_helper = new InsightsCollectionHelper(data);
